let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lT1ej")).then(() => parcelRequire('6zPsL'));